import {
  TCsvQuoteStyleTranslations,
} from './select-csv-quote-style.ts';

const translations: TCsvQuoteStyleTranslations = {
  necessary: {
    title: 'Niezbędny',
    description: 'Ta opcja umieszcza pola w cudzysłowie tylko wtedy, gdy jest to konieczne. Są one wymagane, gdy pola zawierają cudzysłów, separator lub zakończenie rekordu. Cudzysłowy są również wymagane podczas zapisywania pustego rekordu (który jest nieodróżnialny od rekordu z jednym pustym polem). Jest to ustawienie domyślne.',
  },
  always: {
    title: 'Zawsze',
    description: 'To oznacza, że wszystkie pola są ujęte w cudzysłów. Zawsze.',
  },
  non_numeric: {
    title: 'Nienumeryczny',
    description: 'To umieszcza cudzysłowy wokół wszystkich pól, które nie są liczbami. Mianowicie, podczas zapisywania pola, które nie jest parsowane jako prawidłowa liczba zmiennoprzecinkowa lub całkowita, cudzysłowy zostaną użyte, nawet jeśli nie są absolutnie konieczne',
  },
  never: {
    title: 'Nigdy',
    description: 'Pola nigdy nie są ujmowane w cudzysłów, nawet jeśli powoduje to powstanie nieprawidłowych danych CSV (np',
  },
};

export default {
  placeholder: '',
  label: 'Styl cytatu',
  options: translations,
};
